import I18n from 'I18n';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import styled from 'foundations-theming/utils';
import { Button } from 'foundations-components/transitional/components/Button';
import { List } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/transitional/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { getPublicLang } from 'academy-common-lib/utils/url';
import HorizontalLayoutContainer from '../HorizontalLayoutContainer';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error img
import academyLogo from 'bender-url!../../../../../images/hubspot-academy-logo-color.svg';
import LanguageLinks from './LanguageLinks';
import FooterNavGroup from './FooterNavGroup';
import { footerLinks, communityLinks, resourcesLinks, supportAndToolsLinks } from './footerLinks';
import { appendHubsContent } from '../../../../utils/urls';
import NavGroupLink from './NavGroupLink';
import SocialLinks from './SocialLinks';
import LegalLinks from './LegalLinks';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import { ThemedPrimaryButtonMixin } from '../../../../components/ThemedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FooterColumnsContainer = styled.div.withConfig({
  displayName: "PublicPageFooter__FooterColumnsContainer",
  componentId: "gs32hr-0"
})(({
  theme: {
    space
  }
}) => {
  const {
    isNotTablet
  } = useMediaQuery();
  return Object.assign({}, isNotTablet && {
    marginBlockEnd: space[1400],
    display: 'flex',
    flexWrap: 'nowrap',
    gap: space[300],
    justifyContent: 'space-between'
  });
});
const FooterBottom = styled.section.withConfig({
  displayName: "PublicPageFooter__FooterBottom",
  componentId: "gs32hr-1"
})(({
  theme: {
    space,
    color
  }
}) => {
  const {
    isNotTablet,
    isNotLaptop
  } = useMediaQuery();
  return Object.assign({
    borderTop: `1px solid ${color['do-not-use-eerie']}`,
    padding: `${space[800]} 0 ${space[1100]}`
  }, isNotTablet && Object.assign({
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column-reverse',
    alignContent: 'center',
    gap: space[400],
    paddingBottom: space[1100]
  }, isNotLaptop && {
    flexWrap: 'nowrap',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between'
  }));
});
const SupportButton = styled.div.withConfig({
  displayName: "PublicPageFooter__SupportButton",
  componentId: "gs32hr-2"
})(() => {
  const {
    isNotMobile
  } = useMediaQuery();
  return Object.assign({}, ThemedPrimaryButtonMixin(), isNotMobile && {
    width: 'auto'
  });
});
const HubSpotAcademyLogo = styled.div.withConfig({
  displayName: "PublicPageFooter__HubSpotAcademyLogo",
  componentId: "gs32hr-3"
})(() => ({
  img: {
    filter: `brightness(1000%) brightness(95%)`
  }
}));
const PublicPageFooter = () => {
  const publicLang = getPublicLang();
  const {
    isTablet,
    isNotLaptop,
    isNotTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(View, {
      as: "footer",
      backgroundColor: "do-not-use-pantera",
      color: "do-not-use-olaf",
      paddingBlockStart: !isTablet ? '1500' : '800',
      children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
        children: /*#__PURE__*/_jsxs("nav", {
          children: [/*#__PURE__*/_jsxs(FooterColumnsContainer, {
            children: [/*#__PURE__*/_jsx(FooterNavGroup, {
              headingText: I18n.text('academyPublic.publicFooter.communityHeading'),
              children: /*#__PURE__*/_jsx(List, {
                wrapChildren: true,
                children: communityLinks[publicLang].map(link => /*#__PURE__*/_jsx(NavGroupLink, {
                  link: link
                }, link.i18nKey))
              })
            }), /*#__PURE__*/_jsx(FooterNavGroup, {
              headingText: I18n.text('academyPublic.publicFooter.resourcesHeading'),
              children: /*#__PURE__*/_jsx(List, {
                wrapChildren: true,
                children: resourcesLinks[publicLang].map(link => /*#__PURE__*/_jsx(NavGroupLink, {
                  link: link
                }, link.i18nKey))
              })
            }), /*#__PURE__*/_jsx(FooterNavGroup, {
              headingText: I18n.text('academyPublic.publicFooter.supportHeading'),
              children: /*#__PURE__*/_jsx(List, {
                wrapChildren: true,
                children: supportAndToolsLinks[publicLang].map(link => /*#__PURE__*/_jsx(NavGroupLink, {
                  link: link
                }, link.i18nKey))
              })
            }), /*#__PURE__*/_jsxs(View, {
              marginBlockStart: isNotTablet ? '0' : '800',
              textAlign: isNotTablet ? 'right' : 'center',
              children: [/*#__PURE__*/_jsx(SupportButton, {
                children: /*#__PURE__*/_jsx(Button, {
                  href: appendHubsContent(footerLinks.SUPPORT_BUTTON.hrefs[publicLang] || footerLinks.SUPPORT_BUTTON.hrefs.en, I18n.text(footerLinks.SUPPORT_BUTTON.i18nKey)),
                  rel: "noopener noreferrer",
                  target: "_blank",
                  use: "primary",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: footerLinks.SUPPORT_BUTTON.i18nKey
                  })
                })
              }), /*#__PURE__*/_jsx(SocialLinks, {})]
            })]
          }), /*#__PURE__*/_jsx(LanguageLinks, {}), /*#__PURE__*/_jsxs(FooterBottom, {
            children: [/*#__PURE__*/_jsx(LegalLinks, {}), /*#__PURE__*/_jsxs(View, {
              as: "section",
              color: "do-not-use-battleship",
              flexShrink: "0",
              textAlign: isNotLaptop ? 'left' : 'center',
              children: [/*#__PURE__*/_jsx(HubSpotAcademyLogo, {
                children: /*#__PURE__*/_jsx(Image, {
                  alt: I18n.text('academyPublic.publicFooter.hubSpotAcademyLogoAlt'),
                  responsive: false,
                  src: academyLogo,
                  width: "200px"
                })
              }), /*#__PURE__*/_jsx("p", {
                children: /*#__PURE__*/_jsx("small", {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyPublic.publicFooter.copyRight",
                    options: {
                      year: new Date().getFullYear().toString()
                    }
                  })
                })
              })]
            })]
          })]
        })
      })
    })
  });
};
export default PublicPageFooter;